<template>
  <div class="container">
    <el-button
    type="text"
    class="btn-wrapper"
    @click="emitDownloadImageListDialog"
  >
      <el-badge class="mark" :value="downloadImageList.length">
        <i class="el-icon-ali-xiazai icon"></i>
      </el-badge>
    </el-button>
    <el-dialog
      title="切割错误的大图"
      :visible.sync="downloadImageListShow"
      width="60"
    >
      <div class="btn-wrapper-header">
        <el-button
          type="primary"
          size="mini"
          class="btn"
          @click="goClearImages"
          :disabled="downloadImageList.length === 0"
        >清空
        </el-button>
        <el-button
          type="primary"
          size="mini"
          class="btn"
          @click="downloadAllImages"
        >下载全部</el-button
        >
      </div>
      <div class="images-wrapper">
        <div
          class="image-wrapper"
          v-for="image in downloadImageList"
          :key="image"
        >
          <img :src="image" alt="" class="image-item" />
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {mapActions, mapGetters} from 'vuex';
import downloadImagesFormZip from '@/lib/downloadImagesFormZip';

export default {
  name: 'downloadImageButton',
  components: {},
  data () {
    return {
      downloadImageListShow: false
    };
  },
  mounted () {
  },
  methods: {
    ...mapActions([]),
    downloadAllImages() {
      if (this.downloadImageList.length === 0) {
        return this.$message.error("当前没有图片可以下载");
      }
      downloadImagesFormZip(this.downloadImageList);
    },
    emitDownloadImageListDialog() {
      this.downloadImageListShow = true;
    },
    goClearImages() {
      if (this.downloadImageList.length === 0) {
        return this.$message.error("当前没有图片");
      }
      this.$confirm("是否全部清空?", "提示", {
        confirmButtonText: "清空",
        cancelButtonText: "取消清空"
      })
        .then(() => {
          this.clearImages();
        })
        .catch(e => {
          console.log(e);
          this.$message.error("您已取消");
        });
    }
  },
  computed: {
    ...mapGetters(['downloadImageList'])
  },
  watch: {}
};
</script>
<style lang="scss" scoped>
  .container {
    .image-wrapper {
      padding: 5px;
      display: inline-block;
      width: 100px;
      height: 100px;
      .image-item {
        width: auto;
        height: auto;
        max-width: 100%;
        max-height: 100%;
      }
    }
    .btn-wrapper-header {
      position: absolute;
      right: 10px;
      top: 10px;
    }
  }

</style>
